module.exports = __webpack_public_path__ + "static/book_02-960x550-5e057d58e0ce116786ca4414d5db1db0.jpg";